import React, { Component, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import SearchForm from './search-form';

// class FeaturedItemV1 extends Component {
const FeaturedItemV1 = () => {
  let publicUrl = process.env.PUBLIC_URL + '/';
  const staticProducts = [
    {
      //Beachside w/Parking - Las Olas, Airport, Port Evg
      state: 'Florida',
      name: 'Fort Lauderdale',
      img: publicUrl + 'assets/img/prod/beachside.jpg',
      subtitle1: 'Las Olas w/Parking',
      subtitle2: 'Beachside',
      bedrooms: '2',
      beds: '4',
      baths: '2',
      people: '6',
      footage: '800',
      link: 'https://app.ownerrez.com/widgets/a6bdb40c13ac4a4eb329ffca75a7b0b0?view=form&propertyKey=874f148fd8c149a8a6dcc5498b7d5f85',
    },
    {
      //Comfort Oasis
      state: 'New Jersey',
      name: 'Newark',
      img: publicUrl + 'assets/img/prod/comfort_oasis.jpg',
      subtitle1: 'NYC & NWK w/ Free Parking',
      subtitle2: 'Comfort Oasis',
      bedrooms: '2',
      beds: '7',
      baths: '1',
      people: '7',
      footage: '800',
      link: 'https://app.ownerrez.com/widgets/a6bdb40c13ac4a4eb329ffca75a7b0b0?view=form&propertyKey=bfedb7681b554982b9337011d63cfc75',
    },
    // {
    //   //Comfy Cozy retreat - NYC & NWK w/free parking
    //   state: 'New Jersey',
    //   name: 'Bayonne',
    //   img: publicUrl + 'assets/img/prod/comfy_cozy_retreat.jpg',
    //   subtitle1: 'NYC & NWK w/free parking',
    //   subtitle2: 'Comfy Cozy retreat',
    //   bedrooms: '2',
    //   beds: '4',
    //   baths: '1',
    //   people: '5',
    //   footage: '800',
    //   link: 'https://app.ownerrez.com/widgets/a6bdb40c13ac4a4eb329ffca75a7b0b0?view=form&propertyKey=a72863308dd244918e06814430207931',
    // },
    // {
    //   //Cozy Family Getaway
    //   state: 'New Jersey',
    //   name: 'Bayonne',
    //   img: publicUrl + 'assets/img/prod/cozy_family_getaway.jpg',
    //   subtitle1: 'NYC & NWK w/ Free Parking',
    //   subtitle2: 'Cozy Family Getaway',
    //   bedrooms: '2',
    //   beds: '5',
    //   baths: '1',
    //   people: '7',
    //   footage: '800',
    //   link: 'https://app.ownerrez.com/widgets/a6bdb40c13ac4a4eb329ffca75a7b0b0?view=form&propertyKey=becb2c3bf2084b22affb30ec159ee76e',
    // },
    // {
    //   //Cozy Stylish retreat - NYC & NWK w/free parking
    //   state: 'New Jersey',
    //   name: 'Bayonne',
    //   img: publicUrl + 'assets/img/prod/cozy_stylish_retreat.jpg',
    //   subtitle1: 'NYC & NWK w/free parking',
    //   subtitle2: 'Cozy Stylish retreat',
    //   bedrooms: '1',
    //   beds: '2',
    //   baths: '1',
    //   people: '3',
    //   footage: '800',
    //   link: 'https://app.ownerrez.com/widgets/a6bdb40c13ac4a4eb329ffca75a7b0b0?view=form&propertyKey=8ab2b0fffe31499dacf99295f3fed066',
    // },
    {
      //Family & Traveler Haven - NYC & NWK w/free parking
      state: 'New Jersey',
      name: 'Newark',
      img: publicUrl + 'assets/img/prod/family_&_traveler_haven.jpg',
      subtitle1: 'NYC & NWK w/free parking',
      subtitle2: 'Family & Traveler Haven',
      bedrooms: '2',
      beds: '3',
      baths: '1',
      people: '5',
      footage: '800',
      link: 'https://app.ownerrez.com/widgets/a6bdb40c13ac4a4eb329ffca75a7b0b0?view=form&propertyKey=cc1d8296cc81474b95b987d32a170391',
    },
    {
      //Fun Family getaway - NYC & NWK w/free parking
      state: 'New Jersey',
      name: 'Newark',
      img: publicUrl + 'assets/img/prod/fun_family_getaway.jpg',
      subtitle1: 'NYC & NWK w/free parking',
      subtitle2: 'Fun Family getaway',
      bedrooms: '2',
      beds: '4',
      baths: '1',
      people: '8',
      footage: '800',
      link: 'https://app.ownerrez.com/widgets/a6bdb40c13ac4a4eb329ffca75a7b0b0?view=form&propertyKey=9667ba126e1f4707aee1e17a3df830d3',
    },
    {
      //Home Sweet Home - NWK & NYC w/free parking
      state: 'New Jersey',
      name: 'Newark',
      img: publicUrl + 'assets/img/prod/home_sweet_home.jpg',
      subtitle1: 'NWK & NYC w/free parking',
      subtitle2: 'Home Sweet Home',
      bedrooms: '2',
      beds: '3',
      baths: '1',
      people: '5',
      footage: '800',
      link: 'https://app.ownerrez.com/widgets/a6bdb40c13ac4a4eb329ffca75a7b0b0?view=form&propertyKey=b969ac4b703a4eafa3ea5193f3700c8c',
    },
    {
      //Peaceful Hideaway - NYC & NWK w/free parking
      state: 'New Jersey',
      name: 'Newark',
      img: publicUrl + 'assets/img/prod/peaceful_hideaway.jpg',
      subtitle1: 'NYC & NWK w/free parking',
      subtitle2: 'Peaceful Hideaway',
      bedrooms: '1',
      beds: '2',
      baths: '1',
      people: '3',
      footage: '800',
      link: 'https://app.ownerrez.com/widgets/a6bdb40c13ac4a4eb329ffca75a7b0b0?view=form&propertyKey=e67949d75d5a4f2e9b839cebbce1ee3b',
    },

    {
      // Traveler Haven XL
      state: 'New Jersey',
      name: 'Newark',
      img: publicUrl + 'assets/img/prod/traveler_haven_XL.jpg',
      subtitle1: 'NYC & NWK w/free parking',
      subtitle2: 'Traveler Haven XL',
      bedrooms: '2',
      beds: '4',
      baths: '1',
      people: '6',
      footage: '800',
      link: 'https://app.ownerrez.com/widgets/a6bdb40c13ac4a4eb329ffca75a7b0b0?view=form&propertyKey=cf53f5578a984b8a863b2d705313bc86',
    },
    {
      //Urban Haven XL
      state: 'New Jersey',
      name: 'Newark',
      img: publicUrl + 'assets/img/prod/urban_haven_XL.jpg',
      subtitle1: 'NYC & NWK w/ Free Parking',
      subtitle2: 'Urban Haven XL',
      bedrooms: '2',
      beds: '4',
      baths: '1',
      people: '6',
      footage: '800',
      link: 'https://app.ownerrez.com/widgets/a6bdb40c13ac4a4eb329ffca75a7b0b0?view=form&propertyKey=ce24c4e3a4234a02bf8e7ed0377f9705',
    },

    // {
    //   //Warm & Cozy Escape - NYC & NWK w/free parking

    //   state: 'New Jersey',
    //   name: 'Bayonne',
    //   img: publicUrl + 'assets/img/prod/warm_&_cozy_escape.jpg',
    //   subtitle1: 'NYC & NWK w/free parking',
    //   subtitle2: 'Warm & Cozy Escape',
    //   bedrooms: '1',
    //   beds: '2',
    //   baths: '1',
    //   people: '3',
    //   footage: '800',
    //   link: 'https://app.ownerrez.com/widgets/a6bdb40c13ac4a4eb329ffca75a7b0b0?view=form&propertyKey=b6db24e37cc143988c4f70eb0cc15af1',
    // },

    // {
    // 	//
    //  state: '',
    // 	name: '',
    // 	img: publicUrl+'assets/img/product-3/bayonne2.jpg',
    // 	subtitle1: '',
    // 	subtitle2: '',
    // 	bedrooms: '',
    // 	beds: '',
    // 	baths: '',
    // 	people: '',
    // 	footage: '800',
    // 	link: ''
    // },
  ];

  const [products, setProducts] = useState(staticProducts);

  function SearchLocation(city, USState) {
    // console.log("CITY", city);
    // console.log("STATE", USState);
    if (city === 'Choose City' && USState === 'Choose State') {
      setProducts(staticProducts);
    } else if (city === 'Choose City' && USState !== 'Choose State') {
      const newProdArr = staticProducts.filter(
        (product) => product.state === USState,
      );
      setProducts(newProdArr);
    } else {
      const newProdArr = staticProducts.filter(
        (product) => product.name === city,
      );
      setProducts(newProdArr);
    }
  }

  return (
    <div>
      <div
        id='featured-listings'
        className='ltn__product-slider-area ltn__product-gutter pt-115 pb-90'
      >
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='section-title-area ltn__section-title-2--- text-center'>
                {/* <h6 className='section-subtitle section-subtitle-2 ltn__secondary-color'>
                  Properties
                </h6> */}
                <h1 className='section-title' id='section-title-h1'>
                  All Listings
                </h1>
                <SearchForm Filter={SearchLocation} />
              </div>
            </div>
          </div>
          <div className='Side-Slide row'>
            {/* ltn__product-slider-item-three-active slick-arrow-1"> */}
            {/* ltn__product-item */}
            {products.map((product, index) => (
              <div className='col-lg-4' key={index}>
                <a target='blank' href={product.link}>
                  <div className='ltn__product-item ltn__product-item-4 text-center---'>
                    <div className='product-img go-top'>
                      {/* <Link to="/product-details"><img src={publicUrl+"assets/img/product-3/1.jpg"} alt="#" /></Link> */}
                      <div className='product-img-container'>
                        <img src={product.img} alt='#' />
                      </div>
                      {/* <div className="product-badge">
			              <ul>
			                <li className="sale-badge bg-green">For Rent</li>
			              </ul>
			            </div> */}
                      <div className='product-img-location-gallery'>
                        <div className='product-img-location go-top'>
                          <ul>
                            <li>
                              {/* <Link to="/contact"><i className="flaticon-pin" /> Belmont Gardens, Chicago</Link> */}
                              <label>
                                <i className='flaticon-pin' /> {product.name}
                              </label>
                            </li>
                          </ul>
                        </div>
                        {/* <div className="product-img-gallery go-top">
			                <ul>
			                  <li>
			                    <Link to="/product-details"><i className="fas fa-camera" /> 4</Link>
			                  </li>
			                  <li>
			                    <Link to="/product-details"><i className="fas fa-film" /> 2</Link>
			                  </li>
			                </ul>
			              </div> */}
                      </div>
                    </div>
                    <div className='product-info'>
                      {/* <div className="product-price">
			              <span>$34,900<label>/Month</label></span>
			            </div> */}
                      {/* <h2 className="product-title go-top"><Link to="/product-details">New Apartment Nice View</Link></h2> */}
                      <h2 className='product-title go-top'>{product.name}</h2>
                      <div className='product-description'>
                        <p>{product.subtitle1} </p>
                        {/* <br />
                        <p>{product.subtitle2}</p>
                        <br /> */}
                      </div>
                      <ul className='ltn__list-item-2'>
                        <li>
                          <span>
                            {product.people} <i className='flaticon-user-1' />
                          </span>
                          Max Occupancy
                        </li>
                      </ul>
                      <ul className='ltn__list-item-2 ltn__list-item-2-before'>
                        <li>
                          <span>
                            {product.bedrooms} <i className='flaticon-bed' />
                          </span>
                          Bedrooms
                        </li>
                        <li>
                          <span>
                            {product.beds} <i className='flaticon-bed' />
                          </span>
                          Beds
                        </li>
                        <li>
                          <span>
                            {product.baths} <i className='flaticon-clean' />
                          </span>
                          Bathrooms
                        </li>
                        {/* <li><span>{product.footage} <i className="flaticon-square-shape-design-interface-tool-symbol" /></span>
			                square Ft
			              </li> */}
                      </ul>
                    </div>
                    {/* <div className='product-info-bottom'>
                      <div className='real-estate-agent go-top'>
                        <div className='agent-img'>
                          <Link to='/team-details'>
                            <img
                              src={publicUrl + 'assets/img/blog/author.jpg'}
                              alt='#'
                            />
                          </Link>
                        </div>
                        <div className='agent-brief'>
                          <h6>
                            <Link to='/team-details'>William Seklo</Link>
                          </h6>
                          <small>Estate Agents</small>
                        </div>
                      </div>
                      <div className='product-hover-action'>
                        <ul>
                          <li>
                            <a
                              href='#'
                              title='Quick View'
                              data-bs-toggle='modal'
                              data-bs-target='#quick_view_modal'
                            >
                              <i className='flaticon-expand' />
                            </a>
                          </li>
                          <li>
                            <a
                              href='#'
                              title='Wishlist'
                              data-bs-toggle='modal'
                              data-bs-target='#liton_wishlist_modal'
                            >
                              <i className='flaticon-heart-1' />
                            </a>
                          </li>
                          <li>
                            <a
                              href='product-details.html'
                              title='Product Details'
                            >
                              <i className='flaticon-add' />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div> */}
                  </div>
                </a>
              </div>
            ))}
            {/*  */}
          </div>
        </div>
      </div>
      <div className='ltn__modal-area ltn__add-to-cart-modal-area'>
        <div className='modal fade' id='liton_wishlist_modal' tabIndex={-1}>
          <div className='modal-dialog modal-md' role='document'>
            <div className='modal-content'>
              <div className='modal-header'>
                <button
                  type='button'
                  className='close'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  <span aria-hidden='true'>×</span>
                </button>
              </div>
              <div className='modal-body'>
                <div className='ltn__quick-view-modal-inner'>
                  <div className='modal-product-item'>
                    <div className='row'>
                      <div className='col-12'>
                        <div className='modal-product-img'>
                          <img
                            src={publicUrl + 'assets/img/product/7.png'}
                            alt='#'
                          />
                        </div>
                        <div className='modal-product-info go-top'>
                          <h5>
                            <Link to='/product-details'>
                              Brake Conversion Kit
                            </Link>
                          </h5>
                          <p className='added-cart'>
                            <i className='fa fa-check-circle' /> Successfully
                            added to your Wishlist
                          </p>
                          <div className='btn-wrapper'>
                            <Link
                              to='/wishlist'
                              className='theme-btn-1 btn btn-effect-1'
                            >
                              View Wishlist
                            </Link>
                          </div>
                        </div>
                        {/* additional-info */}
                        <div className='additional-info d-none'>
                          <p>
                            We want to give you <b>10% discount</b> for your
                            first order, <br /> Use discount code at checkout
                          </p>
                          <div className='payment-method'>
                            <img
                              src={publicUrl + 'assets/img/icons/payment.png'}
                              alt='#'
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='ltn__modal-area ltn__quick-view-modal-area'>
        <div className='modal fade' id='quick_view_modal' tabIndex={-1}>
          <div className='modal-dialog modal-lg' role='document'>
            <div className='modal-content'>
              <div className='modal-header'>
                <button
                  type='button'
                  className='close'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  <span aria-hidden='true'>×</span>
                  {/* <i class="fas fa-times"></i> */}
                </button>
              </div>
              <div className='modal-body'>
                <div className='ltn__quick-view-modal-inner'>
                  <div className='modal-product-item'>
                    <div className='row'>
                      <div className='col-lg-6 col-12'>
                        <div className='modal-product-img'>
                          <img
                            src={publicUrl + 'assets/img/product/4.png'}
                            alt='#'
                          />
                        </div>
                      </div>
                      <div className='col-lg-6 col-12'>
                        <div className='modal-product-info'>
                          <div className='product-ratting'>
                            <ul>
                              <li>
                                <a href='#'>
                                  <i className='fas fa-star' />
                                </a>
                              </li>
                              <li>
                                <a href='#'>
                                  <i className='fas fa-star' />
                                </a>
                              </li>
                              <li>
                                <a href='#'>
                                  <i className='fas fa-star' />
                                </a>
                              </li>
                              <li>
                                <a href='#'>
                                  <i className='fas fa-star-half-alt' />
                                </a>
                              </li>
                              <li>
                                <a href='#'>
                                  <i className='far fa-star' />
                                </a>
                              </li>
                              <li className='review-total'>
                                {' '}
                                <a href='#'> ( 95 Reviews )</a>
                              </li>
                            </ul>
                          </div>
                          <h3>Brake Conversion Kit</h3>
                          <div className='product-price'>
                            <span>$149.00</span>
                            <del>$165.00</del>
                          </div>
                          <div className='modal-product-meta ltn__product-details-menu-1'>
                            <ul>
                              <li>
                                <strong>Categories:</strong>
                                <span className='go-top'>
                                  <Link to='/blog'>Parts</Link>
                                  <Link to='/blog'>Car</Link>
                                  <Link to='/blog'>Seat</Link>
                                  <Link to='/blog'>Cover</Link>
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className='ltn__product-details-menu-2'>
                            <ul>
                              <li>
                                <div className='cart-plus-minus'>
                                  <input
                                    type='text'
                                    defaultValue='02'
                                    name='qtybutton'
                                    className='cart-plus-minus-box'
                                  />
                                </div>
                              </li>
                              <li>
                                <a
                                  href='#'
                                  className='theme-btn-1 btn btn-effect-1'
                                  title='Add to Cart'
                                  data-bs-toggle='modal'
                                  data-bs-target='#add_to_cart_modal'
                                >
                                  <i className='fas fa-shopping-cart' />
                                  <span>ADD TO CART</span>
                                </a>
                              </li>
                            </ul>
                          </div>
                          <hr />
                          <div className='ltn__social-media'>
                            <ul>
                              <li>Share:</li>
                              <li>
                                <a href='#' title='Facebook'>
                                  <i className='fab fa-facebook-f' />
                                </a>
                              </li>
                              <li>
                                <a href='#' title='Twitter'>
                                  <i className='fab fa-twitter' />
                                </a>
                              </li>
                              <li>
                                <a href='#' title='Linkedin'>
                                  <i className='fab fa-linkedin' />
                                </a>
                              </li>
                              <li>
                                <a href='#' title='Instagram'>
                                  <i className='fab fa-instagram' />
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='ltn__modal-area ltn__add-to-cart-modal-area'>
        <div className='modal fade' id='add_to_cart_modal' tabIndex={-1}>
          <div className='modal-dialog modal-md' role='document'>
            <div className='modal-content'>
              <div className='modal-header'>
                <button
                  type='button'
                  className='close'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  <span aria-hidden='true'>×</span>
                </button>
              </div>
              <div className='modal-body'>
                <div className='ltn__quick-view-modal-inner'>
                  <div className='modal-product-item'>
                    <div className='row'>
                      <div className='col-12'>
                        <div className='modal-product-img'>
                          <img
                            src={publicUrl + 'assets/img/product/1.png'}
                            alt='#'
                          />
                        </div>
                        <div className='modal-product-info go-top'>
                          <h5 className='go-top'>
                            <Link to='/product-details'>
                              Brake Conversion Kit
                            </Link>
                          </h5>
                          <p className='added-cart'>
                            <i className='fa fa-check-circle' />
                            Successfully added to your Cart
                          </p>
                          <div className='btn-wrapper'>
                            <Link
                              to='/cart'
                              className='theme-btn-1 btn btn-effect-1'
                            >
                              View Cart
                            </Link>
                            <Link
                              to='/checkout'
                              className='theme-btn-2 btn btn-effect-2'
                            >
                              Checkout
                            </Link>
                          </div>
                        </div>
                        {/* additional-info */}
                        <div className='additional-info d-none'>
                          <p>
                            We want to give you <b>10% discount</b> for your
                            first order, <br /> Use discount code at checkout
                          </p>
                          <div className='payment-method'>
                            <img
                              src={publicUrl + 'assets/img/icons/payment.png'}
                              alt='#'
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedItemV1;
